import { all, fork } from "redux-saga/effects";
import commonSaga from "./common/commonSaga";

export default function* rootSaga() {
  yield all(commonSaga.map((saga) => fork(saga)));
}
